"use client";

import * as React from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@drpcrd/utils/shared";

const toggleCardVariants = cva(
  "inline-flex items-center justify-center rounded-full text-sm font-medium ring-offset-white transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-primary data-[state=on]:text-white cursor-pointer",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline:
          "border border-neutral-500 bg-white hover:bg-primary hover:text-white ",
      },
      size: {
        default: "h-[36px] px-2",
        sm: "h-9 px-3",
        lg: "py-2 px-3 w-full rounded-2xl justify-start text-lg text-semibold items-center space-x-2 hover:bg-white hover:text-black hover:border-neutral-900 data-[state=on]:text-black data-[state=on]:bg-white data-[state=on]:border-black data-[state=on]:border-[2px] font-semibold",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export const ToggleCard = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleCardVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleCardVariants({ variant, size, className }))}
    {...props}
  />
));

ToggleCard.displayName = TogglePrimitive.Root.displayName;
